import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Col,
  DatePicker,
  Form,
  Input,
  Row,
  Select,
  Typography,
  Upload,
} from 'antd';
import FormHelper from 'helpers/FormHelper';
import { InboxOutlined } from '@ant-design/icons';
import UIHelper from '../../../../../../helpers/UIHelper';
import { Descriptions } from 'antd';

const FormSections = ({ assets = [], file }) => {
  const { t } = useTranslation();
  const fileList = useMemo(() => {
    const l = [];
    if (file?.url) {
      l.push({
        uid: file.id,
        name: file.name,
        status: 'done',
        url: file.url,
      });
    }

    return l;
  }, [file]);

  return (
    <>
      <Row>
        <Col span={24}>
          <Row>
            <Col span={6}>
              <Typography.Title level={3}>{t('Info')}</Typography.Title>
            </Col>
            <Col span={10}>
              <Form.Item label={t('Titolo')} name='title'>
                <Input placeholder={t('Inserisci testo')} />
              </Form.Item>
              <Form.Item label={t('Data pubblicazione')} name='day'>
                <DatePicker format={'DD MMMM YYYY'} style={{ width: '100%' }} />
              </Form.Item>
              <Form.Item label={t('Asset')} name='leasings_asset_id'>
                <Select
                  placeholder={t('Asset')}
                  {...UIHelper.getSelectSearchProps()}
                >
                  <Select.Option value=''>
                    {t('Selezioni opzione')}
                  </Select.Option>
                  {assets.map((company) => (
                    <Select.Option key={company.value} value={company.value}>
                      {company.title}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>
        </Col>
        <Col span={24}>
          <Row>
            <Col span={6}>
              <Typography.Title level={3}>{t('Allegato')}</Typography.Title>
            </Col>
            <Col span={10}>
              <Form.Item
                label={t('File')}
                name='file'
                valuePropName='fileList'
                getValueFromEvent={FormHelper.normFile}
                noStyle
                multiple={false}
              >
                <Upload.Dragger
                  defaultFileList={fileList}
                  name='file'
                  multiple={false}
                  beforeUpload={FormHelper.beforeUpload}
                >
                  <p className='ant-upload-drag-icon'>
                    <InboxOutlined />
                  </p>
                  <p className='ant-upload-text'>
                    {t('Click or drag file to this area to upload1')}
                    'PDF', 'WORD', 'XLSX', 'PPTX', 'CSV'
                    {t('Click or drag file to this area to upload2')}
                  </p>
                </Upload.Dragger>
                <Descriptions column={1} bordered>
                  <Descriptions.Item label={`${t('Formati accettati')}:`}>
                  PDF WORD XLS XLSX PPTX CSV
                  </Descriptions.Item>
                  <Descriptions.Item label={`${t('Dimensione massima')}:`}>
                  20MB
                  </Descriptions.Item>
                </Descriptions>
              </Form.Item>
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
};

export default FormSections;
